<ui-transaction-items [userId]="userId$ | async"
                      [isReviewMode]="true">
</ui-transaction-items>
